import React from 'react';

const Model = ({ link }) => {
  return (
    <section id="3d-model" className="model-container">
      {link ? (
        <>
          <iframe src={link} title="3D Model" width="100%" height="500px" className="model-iframe" />
          <div className="model-overlay">
            <button className="view-model-btn" onClick={() => window.open(link, '_blank')}>
              Voir le modèle 3D
            </button>
          </div>
        </>
      ) : (
        <p>No 3D model selected</p>
      )}
    </section>
  );
};

export default Model;
